const { eventToDoc } = require('../../tools')

exports.saveEvent = async (state, event) => {
  const doc = eventToDoc(Object.assign({}, event, { createdBy: state.user.name }))
  await state.documentsDB.put(doc)
  return doc
}
